import { Injectable } from '@angular/core';
import { IOrgDetail, IOrgOrder, OrgItem } from '../../models/interface/login/i-login';
import { DepartmentsCodeEnum } from '../../models/enum/departments-enum';

@Injectable({
  providedIn: 'root',
})
export class OrganizationOrgService {

  calculateOrder(orgItem: OrgItem, orgId?: DepartmentsCodeEnum): IOrgOrder {
    if (!orgItem) return { firstOrd: null, secondOrd: null };

    const orgList: { orgId: string | null; orgName: string | null; isHead: boolean | undefined }[] = [
      { orgId: orgItem.org_id, orgName: orgItem.org_id_name, isHead: orgItem.org_is_head },
      { orgId: orgItem.org_id_1 ?? null, orgName: orgItem.org_id_1_name ?? null, isHead: orgItem.org_1_is_head },
      { orgId: orgItem.org_id_2 ?? null, orgName: orgItem.org_id_2_name ?? null, isHead: orgItem.org_2_is_head },
      { orgId: orgItem.org_id_3 ?? null, orgName: orgItem.org_id_3_name ?? null, isHead: orgItem.org_3_is_head }
    ].filter(item => (item.isHead !== null));

    const filteredOrgList: IOrgDetail[] = orgList.map(item => ({
      orgId: item.orgId as string,
      orgName: item.orgName as string
    }));

    let firstOrd: IOrgDetail | null = null;
    let secondOrd: IOrgDetail | null = null;
    let hasGroupDirectorOrg: boolean = orgList.length === 2 && orgList[1].isHead === false;
    let hasGroupDirectorForWithdraw: boolean | undefined = orgItem.is_have_group_director_for_withdraw;

    for (let i = 0; i < orgList.length; i++) {
      let checkHead = orgList[i].isHead;
      if (checkHead) {
        firstOrd = { orgId: filteredOrgList[i].orgId, orgName: filteredOrgList[i].orgName };
      } else if (!secondOrd && !orgList[i].isHead) {
        secondOrd = { orgId: filteredOrgList[i].orgId, orgName: filteredOrgList[i].orgName };
        break;
      }
    }

    return { firstOrd, secondOrd, isGroupDirectorOrg: hasGroupDirectorOrg, isGroupDirectorForWithdraw: hasGroupDirectorForWithdraw };
  }
}
